import React from "react";
import {Wrapper} from "./Styled";

const LogoLoading = (props) => {
    return (
        <Wrapper isLoading={props.isLoading} />
    )
};

export default LogoLoading;